import React, { useMemo, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import Button from '@material-ui/core/Button'
import truncate from 'lib/utils/truncateString'
import { useStyles } from './styles'

const DESCRIPTION_PREVIEW_LENGTH = 200

const toPlainText = description =>
  description?.replace(/\s+/g, ' ').trim() || ''

const EventDescription = ({ description }) => {
  const classes = useStyles()
  const [isExpanded, setIsExpanded] = useState(false)

  const plainText = useMemo(() => toPlainText(description), [description])
  const isTruncatable = plainText.length > DESCRIPTION_PREVIEW_LENGTH
  const displayDescription =
    isExpanded || !isTruncatable
      ? description
      : truncate(plainText, DESCRIPTION_PREVIEW_LENGTH, '...')

  if (!description) return null

  return (
    <>
      <ReactMarkdown className={classes.bodyText}>
        {displayDescription}
      </ReactMarkdown>
      {isTruncatable ? (
        <Button
          className={classes.readMoreButton}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Read less' : 'Read more'}
        </Button>
      ) : null}
    </>
  )
}

export default EventDescription
